import { render, staticRenderFns } from "./cell-renderer-bewertung.vue?vue&type=template&id=63507103&scoped=true"
import script from "./cell-renderer-bewertung.vue?vue&type=script&lang=js"
export * from "./cell-renderer-bewertung.vue?vue&type=script&lang=js"
import style0 from "./cell-renderer-bewertung.vue?vue&type=style&index=0&id=63507103&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63507103",
  null
  
)

export default component.exports